<template>
  <div class="item"><slot></slot></div>
</template>

<script>
// eslint-disable
export default {
  name: 'SliderComponent',
  props: {
    index: { required: true },
  },
  computed: {
    /*index() {
      return this.$parent.$el.children.indexOf(this.$el);
    },*/
    show() {
      return this.$parent.index === this.index;
    },
  },
  mounted() {
    if (this.$parent.indicator_list) {
      this.$parent.indicator_list.push(this.index);
    }

    if (this.index === 0) {
      this.$el.classList.add('active');
    }
  },
};
</script>
